import useSWR from 'swr';
import { api, ApiKey } from 'api';

interface ChatLeanCount {
  count: number;
}

export const useGetChatLeanActivity = (projectId?: string) => {
  const { data, isLoading, error } = useSWR<ChatLeanCount>(
    projectId ? `${ApiKey.ChatLean}?projectId=${projectId}` : null,
    (url: string) => api.get(url).then((res) => res.data)
  );

  return {
    count: data?.count ?? 0,
    isLoading,
    error,
  };
};
